import type { MouseEvent } from "react";

/**
 * A plain primary left-click with no modifier: the click we enhance from a real `<a href>` into
 * client-side navigation. A modified click (open in new tab), a middle click, or an already-handled
 * event falls through to the anchor's native href, so right-click / cmd-click / open-in-new-tab keep
 * working. The progressive-enhancement seam shared by the header and the Compendium tabs.
 */
export function isPlainNavClick(e: MouseEvent): boolean {
  return (
    !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
  );
}
